import { render, staticRenderFns } from "./Commandes.vue?vue&type=template&id=5e4008ba&scoped=true&"
import script from "./Commandes.vue?vue&type=script&lang=js&"
export * from "./Commandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4008ba",
  null
  
)

export default component.exports